/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Language_Code_PlaceholderInputs */



/**
* | output |
* | --- |
* | "eng" |
*
* @param {Image_Export_Language_Code_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_language_code_placeholder = /** @type {((inputs?: Image_Export_Language_Code_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Language_Code_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("eng")
	if (locale === "de") return /** @type {LocalizedString} */ ("eng")
	if (locale === "it") return /** @type {LocalizedString} */ ("inglese")
	if (locale === "ru") return /** @type {LocalizedString} */ ("англ.")
	if (locale === "es") return /** @type {LocalizedString} */ ("eng")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("eng")
	if (locale === "ja") return /** @type {LocalizedString} */ ("英語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इंग्लैंड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("eng")
	return /** @type {LocalizedString} */ ("eng")
});